import { API } from "../../../utils";

export const getTenantTaxingSettingsApi = async () => {
  const res = await API.get("/settings/taxing");
  return res.data;
};

export const updateTenantTaxingSettingsApi = async (payload) => {
  const res = await API.put("/settings/taxing", payload);
  return res.data;
};
